<template>
  <div v-if="!simcSchema.$disabled" class="picker">
    <v-select
      label-field="name"
      value-field="symbol"
      :disabled="disabled"
      :model="simcSchema"
      :values="cities"
      @input="setCity"
    />
  </div>
</template>

<script>
import axios from 'axios';

import vSelect from './vue-select.vue';

// @vuese
// Input na SIMC-a
// @group Components
export default {
  name: 'WSimcPicker',
  components: { vSelect },
  props: {
    // URL do TERYT API
    url: { type: String, required: false, default: 'https://teryt.api.witkac.pl' },
    // Schema
    model: { type: Object, required: false },
    // Schema SIMCu
    simcModel: { type: Object, required: false },
    // Schema miasta
    cityModel: { type: Object, required: false },
    // Wartość TERC-a
    terc: { type: String, required: true },
    // Tekst do wyświetlenia w przypadku pustej listy
    emptyListMsg: { type: String, required: false, default: '' },
    // Czy pokazywać błędy
    showError: { type: Boolean, default: true },
    // Czy nieaktywny
    disabled: { type: Boolean, default: false }
  },
  data() {
    return { cities: [] };
  },
  computed: {
    simcSchema() {
      return this.simcModel || this.model.simc;
    },
    citySchema() {
      return this.cityModel || this.model.city;
    }
  },
  watch: {
    terc(newValue) {
      this.getCityList();
    },

    'citySchema.$model'(newValue, oldValue) {
      if (newValue === oldValue || !this.cities.length) {
        return;
      }
      this.autoselectCityByName(newValue);
    }
  },
  beforeMount() {
    this.getCityList();
  },
  methods: {
    // @vuese
    // Pobiera listę miejscowości
    async getCityList() {
      if (this.terc.length >= 6 && this.simcSchema?.$model) {
        const cities = await axios
          .get(`${this.url}/simc`, {
            params: { terc: this.terc?.substr(0, 6), type: this.terc[6], symbol: this.simcSchema.$model }
          })
          .then(response => response.data.list);

        if (cities.length > 0) {
          this.cities = cities;
          return;
        }
      }

      if (this.terc.length >= 6) {
        axios
          .get(`${this.url}/simc`, { params: { terc: this.terc?.substr(0, 6), type: this.terc[6] } })
          .then(res => {
            this.cities = res.data.list;
            if (this.cities.length === 1) {
              this.autoselectCity(this.cities[0]);
            } else if (this.citySchema.$model) {
              this.autoselectCityByName(this.citySchema.$model, true);
            } else {
              this.clearValues();
            }
          })
          .catch(error => {
            this.clearValues();
          });
      } else {
        this.$set(this, 'cities', []);
      }
    },
    // @vuese
    // Ustawia simc
    setCity(selectedCity) {
      this.citySchema.$setData(selectedCity?.name);
      this.$emit('update');
    },
    // @vuese
    // Zapisuje wybraną wartość w schemie
    // @arg `val` - obiekt z nazwą oraz symbolem miejscowości
    autoselectCity(city) {
      this.citySchema.$setData(city?.name);
      this.simcSchema.$setData(city?.symbol);
    },
    // @vuese
    // Ustawia automatycznie wybrane miasto po nazwie
    autoselectCityByName(cityName, clearIfNotFound = false) {
      const selectedCity = this.cities.find(city => city.name === cityName);
      if (selectedCity) {
        this.simcSchema.$setData(selectedCity.symbol);
      } else if (clearIfNotFound) {
        this.clearValues();
      }
    },
    // @vuese
    // Czyści wartości schemy
    clearValues() {
      this.citySchema.$setData(null);
      this.simcSchema.$setData(null);
      this.$emit('update');
    }
  }
};
</script>
